module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('b', [_vm._v("Acknowledgements")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" am grateful to Mick Crumplin for assistance on medical matters, Nigel Lipscombe for military matters, Piers Mackesy for sending me a translation of his paper on the abortive Cadiz landing, Bob Sutcliffe for information on the transports after the Convention of Cintra, the staff at the British Library, The National Archives at Kew and the library at the Royal Military Academy at Sandhurst, and as always, my husband, Ken Maxwell-Jones, for research assistance, chauffeuring duties, his tolerance of my obsession with Moore for the best part of five years and constant provision of excellent coffee.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40121bba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgements.vue
// module id = 75
// module chunks = 0